import React from "react";
import ReactDOM from "react-dom";
import { ScenarioElement } from "../../../../model/playerConfiguration/ScenarioElement";
import { ScenarioPath } from "../../../../model/scenarioPath/ScenarioPath";
import { PartComponent } from "../common/PartComponent";
import { SliderComponent } from "../common/SliderComponent";

import "@styles/c-mobileSeekbar.scss";
import { ScenarioTimeComponent } from "../desktop/ScenarioTimeComponent";
import { LogoComponent } from "../common/LogoComponent";

interface Props {
  isDisabled?: boolean;
  isHidden: boolean;
  isLogoVisible: boolean;
  logo?: string;
  logoUrl?: string;
  scenarioPath: ScenarioPath;
  totalTime: number;
  ellapsedTime: number;
  bufferedTime: number;
  onSeekTo: (time: number) => void;
  onJumpToScenarioElement: (scenarioElement: ScenarioElement, progress: number) => void;
  onSliderInteractionStarted: () => void;
  onSliderInteractionEnded: (wasChanging: boolean) => void;
  isMultiElementScenario: boolean;
}

interface State {}

export class MobileSeekbarComponent extends React.Component<Props, State> {
  private slider: SliderComponent;
  private sliderHtml: HTMLElement;

  render() {
    const {
      isDisabled,
      isMultiElementScenario,
      logo,
      logoUrl,
      isLogoVisible,
      scenarioPath,
      totalTime,
      ellapsedTime,
      bufferedTime,
      onSeekTo,
      onJumpToScenarioElement,
      onSliderInteractionStarted,
      onSliderInteractionEnded,
    } = this.props;

    const progress = ellapsedTime / totalTime;
    const bufferingProgress = bufferedTime / totalTime;

    return (
      <div className={"c-mobileSeekbar"}>
        {isDisabled && <div className="c-mobileSeekbar__disabledCover" />}
        <div className={"c-mobileSeekbar__status"}>
          <ScenarioTimeComponent
            className={"c-mobileSeekbar__scenarioTime"}
            ellapsedTime={ellapsedTime}
            totalTime={totalTime}
            isMultiElementScenario={isMultiElementScenario}
          />
          {isLogoVisible ? <LogoComponent src={logo} href={logoUrl} className="c-mobileSeekbar__logo" /> : <div />}
        </div>

        <div className="c-mobileSeekbar__seekbar">
          {scenarioPath.displayedPastParts.map((part) => (
            <PartComponent
              className={"c-mobileSeekbar__part"}
              key={part.id}
              part={part}
              onPartClicked={(scenarioElement, jumpProgress) => onJumpToScenarioElement(scenarioElement, jumpProgress)}
            />
          ))}
          <SliderComponent
            ref={(element) => (this.slider = element)}
            className="c-mobileSeekbar__slider"
            style={{
              flexBasis: `${scenarioPath.currentPart.size}%`,
            }}
            value={progress}
            isHandleAlwaysVisible={true}
            secondaryValue={bufferingProgress}
            onSliderInteraction={(value, isChanging) => isChanging && onSeekTo(value * totalTime)}
            onChangingSliderInteractionStarted={onSliderInteractionStarted}
            onSliderInteractionEnded={onSliderInteractionEnded}
          />
          {scenarioPath.displayedFutureParts.map((part) => (
            <div
              className="c-mobileSeekbar__part"
              style={{
                flexBasis: `${part.size}%`,
              }}
              key={part.id}
            />
          ))}
        </div>
      </div>
    );
  }

  componentDidMount() {
    this.sliderHtml = ReactDOM.findDOMNode(this.slider) as HTMLElement;
  }

  private calculateTooltipX() {
    if (!this.slider) {
      return 0;
    }

    const { ellapsedTime, totalTime } = this.props;
    const progress = ellapsedTime / totalTime;

    const sliderBoundingRect = this.sliderHtml.getBoundingClientRect();

    return sliderBoundingRect.left + sliderBoundingRect.width * progress;
  }
}
